import { useEffect } from "react";

import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { CheckoutV2LoyaltyChoice, checkoutV2Slice } from "@jti/store/slices/checkoutV2Slice";
import { useGetCustomerCartIdQuery } from "@jti/store/slices/magentoApiSlice";

import { getLoyaltyUserSelection } from "../../utils";

export const useLoyaltyUserSelection = () => {
  const dispatch = useDispatch();
  const { data: cartIdData } = useGetCustomerCartIdQuery();
  const cartId = cartIdData?.customerCart?.id;
  const currentLoyaltyChoice = useSelector((store) => store.checkoutV2.loyaltyPointsState.loyaltyChoice);

  const userSelection = getLoyaltyUserSelection();
  const userSelectionCartId = userSelection.cartId;
  const userSelectionChoice = userSelection.loyaltyChoice;

  useEffect(() => {
    if (!cartId) return;

    const storageChoice = userSelectionCartId === cartId ? userSelectionChoice : CheckoutV2LoyaltyChoice.COLLECT;

    if (currentLoyaltyChoice === undefined || currentLoyaltyChoice !== storageChoice) {
      dispatch(checkoutV2Slice.actions.setLoyaltyChoice(storageChoice));
    }
  }, [cartId, currentLoyaltyChoice, dispatch, userSelectionCartId, userSelectionChoice]);

  return {
    userSelectionChoice,
  };
};
